module.exports = __webpack_public_path__ + "img/card3.8e0b0c82.png";